/** অ্যাপের নোটিফিকেশন। */
export const notifications = {
    title: "নোটিফিকেশন",
    open: "নোটিফিকেশন",
    unread: "{{count}}টি পড়া হয়নি",
    empty: "নতুন কিছু নেই।",
    markAllRead: "সব পড়া হয়েছে",
    types: {
        role_assigned: "আপনাকে {{roleName}} ভূমিকা দেওয়া হয়েছে।",
        stock_negative: "{{productName}} ({{sku}}) শূন্যের নিচে নেমেছে: হাতে {{onHand}}।",
        pos_sync_stalled: "{{deviceName}}-এ {{pendingCount}}টি বিল সিঙ্কের অপেক্ষায়।",
        report_ready: "আপনার {{report}} এক্সপোর্ট ডাউনলোডের জন্য তৈরি।",
        report_failed: "আপনার {{report}} এক্সপোর্ট তৈরি করা যায়নি। আবার চেষ্টা করুন।",
        billing_payment_approved: "আপনার {{amount}} পেমেন্ট অনুমোদিত হয়েছে। {{detail}} চালু।",
        billing_dunning: "আপনার সাবস্ক্রিপশনের পেমেন্ট দরকার ({{date}})। প্ল্যান ও বিলিং খুলুন।",
        billing_payment_rejected: "আপনার {{amount}} পেমেন্ট অনুমোদন হয়নি: {{detail}}",
        plan_limit_warning: "আপনার প্ল্যানের {{limit}}টির মধ্যে {{usage}}টি ব্যবহার হয়েছে ({{level}}%)। আরও যোগ করতে প্ল্যান আপগ্রেড করুন।",
    },
};
//# sourceMappingURL=notifications.js.map